import { memo } from "react";

import type { ForArrayType } from "@/components/features/_model/types/auto-generator-for-view-model";
import { QuestionConnection as Question } from "@/components/features/items/edit/_shared/ui/components/main/questions/connection";

import type { FormOptionType } from "@/components/ui/form/_types/type";

import type { CheckedState } from "@radix-ui/react-checkbox";

type Props = {
	availableItemIDs: ForArrayType<string[]>;
	rawAvailableItemIDs: string[];
	nameAndIDOptions: FormOptionType[];
	onSetAvailableItemIDs: (_input: CheckedState, item: FormOptionType) => void;
};

export const QuestionPlanDiscountConnection = memo(
	({ availableItemIDs, rawAvailableItemIDs, nameAndIDOptions, onSetAvailableItemIDs }: Props) => {
		const title = "適用可能なディスカウント";
		const guide =
			"このプランで適用可能なディスカウントを選択しましょう。ゲストが１度に適用可能なディスカウントは１つだけです。<br />※一覧には公開中のディスカウントと、このプランに紐づけ済みのディスカウントを表示します。紐づけ済みで非公開のものは先頭に【非公開】と付きます。";

		return (
			<Question
				title={title}
				guide={guide}
				availableItemIDs={availableItemIDs}
				rawAvailableItemIDs={rawAvailableItemIDs}
				nameAndIDOptions={nameAndIDOptions}
				onSetAvailableItemIDs={onSetAvailableItemIDs}
			/>
		);
	},
);

QuestionPlanDiscountConnection.displayName = "QuestionPlanDiscountConnection";
